<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>




      
      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد ترانسفر
        </b-button>
      </b-col>
    </b-row>
    <div v-if="cars">
      <b-row>
        <b-col sm="12" md="5" lg="4">
          <b-form-group label="تاریخ شروع:" label-for="start-date">
            <date-picker
                v-model="filters.dateStart"
                format="YYYY-MM-DD"
                display-format="jYYYY-jMM-jDD"
                :placeholder="'انتخاب تاریخ شروع'"
                :auto-submit="true"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12" md="5" lg="4">
          <b-form-group label="تاریخ پایان:" label-for="end-date">
            <date-picker
                v-model="filters.dateEnd"
                format="YYYY-MM-DD"
                display-format="jYYYY-jMM-jDD"
                :placeholder="'انتخاب تاریخ پایان'"
                :auto-submit="true"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12" md="2" lg="4" class="d-flex align-items-end">
          <b-button @click="getCars" variant="primary">اعمال فیلترها</b-button>
        </b-col>
      </b-row>

      <b-col sm="12" md="7" lg="8">
        <search-services
            @searchBase="searchBase"
            :selectedFilter="selectedFilter"
            :submitLoading="searchBasesubmitLoading"
            :isSearchResult="isSearchResult"
            ref="ownersSearchComponent"
            class="w-100"
            v-model="searchInput"
        />
      </b-col>

      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>کد</b-th>
            <b-th>ترتیب</b-th>
            <b-th>عنوان</b-th>
            <b-th>شهر</b-th>
            <b-th>لیدر</b-th>
<!--            <b-th>تاریخ ایجاد</b-th>-->
            <b-th>هزینه نمایش </b-th>
            <b-th>وضعیت تقویم</b-th>
            <b-th> نمایش ص اصلی </b-th>
            <b-th>آژانس</b-th>
            <b-th>وضعیت</b-th>
            <b-th>عملیات</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr  v-for="(car, index) in cars" :key="car.id">
            <b-th>
              <a
                  target="_blank"
                  :href="
                  'https://roomtoor.com/car/' +
                  car.category.slug +
                  '-' +
                  car.code
                "
              >
                {{car.code}}
              </a>
            </b-th>
            <b-th>
              <span v-if="car.show_order_number">
                {{ car.show_order_number}}
              </span>
              <span v-else>
                ----
              </span>
            </b-th>

            <b-th>
              <a
                  target="_blank"
                  :href="
                  'https://roomtoor.com/car/' +
                  car.category.slug +
                  '-' +
                  car.code
                "
              >
                {{car.name}}
              </a>
            </b-th>
            <b-td>
              {{ car.city.name }}
            </b-td>

            <b-td>
              <a :href="`https://roomtoor.com/user/host/${car.host.token}`" target="_blank">
                <span class="pl-1">        {{ car.host.full_name }}</span>
              </a>
              <a href="">
                <b-badge variant="primary" v-if="car.host.mobile">
                  {{   car.host.mobile.replace("+98","0") }}
                </b-badge>
              </a>
            </b-td>
<!--            <b-td>
              {{
                new Date(car.created_at).toLocaleString("fa-IR", {
                  timeZone: "Iran",
                })
              }}
            </b-td>-->

            <b-th>
              <span v-if="car.price" class="text-success">
                   {{numberFormat(car.price)}}
              </span>
              <span v-else class="text-danger">
                قیمت  ندارد
              </span>

            </b-th>

            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0">
                  <span class="font-weight-bold" v-if="car.close_booking === 'active'" style="color: #00c700">
                    باز
                  </span>
                <span v-else>
                  بسته
                </span>
              </b-col>
            </b-td>

            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0">
                  <span class="font-weight-bold" v-if="car.show_index_page === true" style="color: #00c700">
                    فعال
                  </span>
                <span v-else>
                  غیرفعال
                </span>
              </b-col>
            </b-td>

            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0">
                  <span class="font-weight-bold" v-if="car.show_index_page === true" style="color: #00c700">
                    فعال
                  </span>
                <span v-else>
                  غیرفعال
                </span>
              </b-col>
            </b-td>
            <b-td>
                <span v-if="car.agency==='active'" style="color: #00c700">
                  فعال
                </span>
              <span v-else>
                غیرفعال
              </span>
            </b-td>
            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0"
                  :class="
                  car.status != 'active' ? 'text-danger' : 'text-success'
                "
              >
                {{ car.status == "active" ? "" : "غیر" }}فعال
              </b-col>
            </b-td>

            <b-td>
              <b-col class="d-flex align-items-center">
                <router-link
                    v-if="car.checkItems[0] && car.checkItems[0].serviceable_type==='App\\Models\\Car'"
                    :to="{ name: 'checkItems', params: {type:'car', id: car.id,name:car.name } }"
                    variant="flat-primary"
                    v-b-tooltip.hover.top="car.checkItems[0].description"
                    class="font-weight-bolder btn"
                >
                  <AlertTriangleIcon style="color: #00b782" v-if="car.checkItems[0].status==='complete'" />
                  <AlertTriangleIcon v-else style="color: #fcb200" />
                </router-link>
                <router-link
                    v-else
                    :to="{ name: 'checkItems', params: {type:'car', id: car.id,name:car.name } }"
                    variant="flat-primary"
                    v-b-tooltip.hover.top="'مشکلی ثبت نشده'"
                    class="font-weight-bolder btn"
                >
                  <AlertTriangleIcon />

                </router-link>

                 <router-link
                  :to="{ name: 'specificTypeComments', params: {type:'car', id: car.id } }"
                  variant="flat-secondary"
                  class="font-weight-bolder btn"
                >
                  <BIconChatRightTextFill />
                </router-link>
                <router-link
                    :to="{ name: 'statisticsOneCars', params: {type:'car', id: car.id,name:car.name } }"
                    variant="flat-secondary"
                    class="font-weight-bolder btn"
                >
                  <feather-icon
                      icon="SlidersIcon"
                      size="28"
                  />
                </router-link>

                <router-link
                    :to="{ name: 'carsBlockCalender', params: { id: car.id },query:{name:car.name} }"
                    variant="flat-secondary"
                    class="font-weight-bolder btn"
                >
                  <MinusCircleIcon />
                </router-link>

                <router-link
                    :to="{ name: 'carsCalender', params: { id: car.id } }"
                    variant="flat-secondary"
                    class="font-weight-bolder btn"
                >
                  <BIconCalendar />
                </router-link>
<!--                <b-button
                    @click="showConfirmModal(car)"
                    variant="flat-danger"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Trash2Icon" size="20" />
                </b-button>-->
                <b-button
                    @click="showFormModal(car, index)"
                    variant="flat-secondary"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Edit2Icon" size="20" />
                </b-button> </b-col
              >
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <pagination
          ref="carsPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>
    <b-sidebar
        width="98%"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
        id="car_wizard"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش ترانسفر" : "ایجاد ترانسفر" }}
            </h3>
          </div>
        </div>
      </template>
      <car-wizard
          @deleteImage="deleteImage"
          ref="carInput"
          @getCars="getCars"
          :provinces="provinces"
            
      ></car-wizard>


    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BIconCalendar,
  BIconChatRightTextFill,
  VBTooltip, BBadge
} from "bootstrap-vue";
import debounce from 'lodash/debounce';
import Ripple from 'vue-ripple-directive'
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import { mapMutations, mapState, mapActions } from "vuex";
import { forEach } from "postcss-rtl/lib/affected-props";
import CarWizard from "@/components/CarWizard.vue";
import SearchServices from "@/components/SearchServices.vue";
import AlertTriangleIcon from "vue-feather-icons/icons/AlertTriangleIcon";
import MinusCircleIcon from "vue-feather-icons/icons/MinusCircleIcon";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    BBadge,
    MinusCircleIcon,
    AlertTriangleIcon,
    SearchServices,
    CarWizard,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BIconCalendar,
    BIconChatRightTextFill,
    datePicker: VuePersianDatetimePicker,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      filters: {
        dateStart: '',
        dateEnd: '',
      },
      isSearchResult:false,
      searchBasesubmitLoading:false,
      selectedFilter:[],
      Dates: [],
      carIndex: 0,
      itemArray: [
        {
          Item: "ACC",
          Price: 10,
          hasPrice: true,
        },
        {
          Item: "BCC",
          Price: "",
          hasPrice: false,
        },
        {
          Item: "CCC",
          Price: "",
          hasPrice: false,
        },
        {
          Item: "DCC",
          Price: "",
          hasPrice: false,
        },
        {
          Item: "ECC",
          Price: "",
          hasPrice: false,
        },
      ],
      provinces: [],

      perPage: 30,
      page: 1,
      buildings: [],
      cars: null,

      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "شهر",
          slug: "city",
          sortable: false,
        },
        {
          title: "ساختمان",
          slug: "building",
          sortable: true,
        },
        {
          title: "نام",
          slug: "name",
          sortable: true,
        },
        {
          title: "میزبان",
          slug: "owner",
          sortable: false,
        },
        {
          title: "تعداد",
          slug: "count",
          sortable: true,
        },
        {
          title: "تاریخ ایجاد",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      buildingsCancelToken: undefined,
      carInput: {
        id: "",
        building_id: "",
        name: "",
        description: "",
        body: "",
        count: "",
        bedrooms: "",
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getCars();
    this.getCarsPrerequisite("regulations", "regulations");
    this.getCarsPrerequisite("rules", "rules");
    this.getCarsPrerequisite("categories", "categories");
    this.getProvinces();
    this.getUrlParams();
  },
  created() {
    this.debouncedGetReservations = debounce(this.getCars, 500);
  },
  watch: {
/*    searchInput(value) {
      this.page = 1;
      this.getCars();
    },*/
    searchInput(value) {
      this.page = 1; // Reset the page to the beginning
      if (value.trim().length) { // Ensure there is actual input to search for
        this.debouncedGetReservations();
      }
    },
/*    searchInput() {
      if (this.searchInput) {
        this.getCars();
      }
    },
    selectedFilter: {
      deep: true,
      handler() {
        if (this.selectedFilter.length && this.searchInput) {
          this.getCars();
        }
      }
    },*/
    perPage(value) {
      this.page = 1;
      this.getCars();
    },
    page(value) {
      this.getCars();
    },
  },
  computed: {
    ...mapState([
      "regulations_state",
      "rules_state",
      "categories_state",
    ]),
  },

  methods: {
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },
    getUrlParams() {
      if ("filter[name]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[name]`];
        this.selectedFilter.push("name");
      }
      if ("filter[code]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[code]`];
        this.selectedFilter.push("code");
      }
      if ("filter[host]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[host]`];
        this.selectedFilter.push("host");
      }
      if ("filter[city]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[city]`];
        this.selectedFilter.push("city");
      }
      if ("per_page" in this.$route.query) {
        this.perPage = Number(this.$route.query[`per_page`]);
        this.$refs.userPerPageComponent.perPage = this.perPage;
      }
      if ("page" in this.$route.query) {
        this.page = this.$route.query[`page`];
      }
     // console.log("this.selectedFilter", this.selectedFilter);
    },
    searchBase(data) {
     // console.log("data", data);
      this.selectedFilter = data.selectedFilter;
      this.searchInput = data.searchInput;
      this.isSearchResult = this.searchInput !== "" && data.type !== "delete";
      this.searchBasesubmitLoading = true;
      this.getCars();
    },
/*
    searchBase(data) {
      console.log("data", data);

      // Only update searchInput and selectedFilter if needed
      if (data.selectedFilter.length > 0) {
        const filterCriteria = ['name', 'code', 'host', 'city'];
        const isFilterSelected = data.selectedFilter.some(filter => filterCriteria.includes(filter));
        if (isFilterSelected) {
          this.searchInput = data.searchInput;
        }
        this.selectedFilter = data.selectedFilter;
      }

      this.searchBasesubmitLoading = true;

      // Determine if a search result should be shown
      this.isSearchResult = !!this.searchInput;

      if (data.type === "delete") {
        this.isSearchResult = false;
      }

      // Trigger the search
      this.getCars();
    },
*/


    deleteImage(image) {
      let carIndex = 0;
      console.log("this.cars.images", this.cars);
      this.cars[this.carIndex].images = Object.values(
          this.cars[this.carIndex].images
      ).filter((carItem, index) => {
        if (carItem.id == image.id) {
          carIndex = index;
        }
        return carItem.id !== image.id;
      });
    },

    getProvinces(search, loading) {
      if (typeof this.provincesCancelToken != typeof undefined) {
        this.provincesCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.provincesCancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,
        //  this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/states",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.provinces = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getCarsPrerequisite(stateName, url) {
      // if (typeof this.cancelToken != typeof undefined) {
      //   this.cancelToken.cancel("Operation canceled due to new request.");
      // }
      //Save the cancel token for the current request
      // this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: `/admin/cars/${url}`,
        // params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this[stateName] = data.data;
            this[stateName].forEach((element) => {
              element["disable"] = false;
            });
          })
          .catch((err) => {
            console.log(err);
          });
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getCars();
    },

    async getCars() {
      if (this.cancelToken) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      this.cancelToken = this.$http.CancelToken.source();
      this.searchBasesubmitLoading = true;

      let params = {
        per_page: this.perPage,
        page: this.page,
      };

      if (this.searchInput) {
        if (this.selectedFilter.includes("name")) params["filter[name]"] = this.searchInput;
        if (this.selectedFilter.includes("code")) params["filter[code]"] = this.searchInput;
        if (this.selectedFilter.includes("host")) params["filter[host]"] = this.searchInput;
        if (this.selectedFilter.includes("city")) params["filter[city]"] = this.searchInput;
      }

      if (this.filters.dateStart && this.filters.dateEnd) {
        params["filter[created_between][]"] = [this.filters.dateStart, this.filters.dateEnd];
      }

      try {
        const response = await this.$http({
          method: "get",
          url: "/admin/cars",
          params: params,
          paramsSerializer: params => {
            return Object.entries(params).map(([key, value]) => {
              if (Array.isArray(value)) {
                return value.map(v => `${key}=${encodeURIComponent(v)}`).join('&');
              }
              return `${key}=${encodeURIComponent(value)}`;
            }).join('&');
          },
          cancelToken: this.cancelToken.token,
        });

        this.cars = response.data.data;
        this.paginationData = response.data.meta;
        this.isSearchResult = true;
      } catch (err) {
        if (!this.$http.isCancel(err)) {
          console.error(err);
        }
      } finally {
        this.searchBasesubmitLoading = false;
      }
    },


/*    async getCars() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        "filter[name]": this.selectedFilter.includes("name")
            ? this.searchInput
            : "",
        "filter[code]": this.selectedFilter.includes("code")
            ? this.searchInput
            : "",
        "filter[host]": this.selectedFilter.includes("host")
            ? this.searchInput
            : "",
        "filter[city]": this.selectedFilter.includes("city")
            ? this.searchInput
            : "",
        per_page: this.perPage,
        page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/cars",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.cars = data.data;
            this.paginationData = data.meta;
            this.searchBasesubmitLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.searchBasesubmitLoading = false;
          });
      this.cars = [];
      this.formModal = false;
    },*/
    showConfirmModal(car) {
      this.$bvModal
          .msgBoxConfirm(
              `آیا از حذف ترانسفر مطمئن هستید ؟  : ${car.name}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let carIndex = 0;
              this.cars = await this.cars.filter(
                  (carItem, index) => {
                    if (carItem.id == car.id) {
                      carIndex = index;
                    }
                    return carItem.id !== car.id;
                  }
              );

              const requestData = {
                method: "delete",
                url: `admin/cars/${car.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `ترانسفر: ${car.name}  با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.cars.splice(carIndex, 0, car);
                  });
            }
          });
    },
 /*   formatePrices(prices, type) {
      if (prices.name && prices.name == "test") {
        return prices;
      }
      if (type == "prices") {
        var formatedPrices = prices;
        if (prices.normal_dayes)
          formatedPrices.normal_dayes = this.formatnumber(prices.normal_dayes);
        if (prices.weekend_days)
          formatedPrices.weekend_days = this.formatnumber(prices.weekend_days);
        if (prices.peack_days)
          formatedPrices.peack_days = this.formatnumber(prices.peack_days);
        if (prices.extra_guest)
          formatedPrices.extra_guest = this.formatnumber(prices.extra_guest);
        if (prices.pricePerBaby.price !== null) {
          formatedPrices.pricePerBaby.price = this.formatnumber(
              prices.pricePerBaby.price
          );
        }
        if (prices.pricePerAnimal.price !== null) {
          formatedPrices.pricePerAnimal.price = this.formatnumber(
              prices.pricePerAnimal.price
          );
        }
        return formatedPrices;
      } else {
        var formatedSpecial_services = prices;
        if (prices && prices[0] !== null) {
          Object.keys(prices).forEach((element) => {
            formatedSpecial_services[element].price = this.formatnumber(
                prices[element].price
            );
          });

          return formatedSpecial_services;
        }
      }
    },
    formatnumber(newValue) {
      console.log("newValue", newValue);
      const result = newValue
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },*/
    //     monthsBetweenDates(startDate, endDate) {
    //       const now = startDate,
    //         dates = [];

    //       while (now.isSameOrBefore(endDate)) {
    //         // console.log(now.format("dddd"))
    //         if (
    //           now.format("dddd") === "پنج‌شنبه" ||
    //           now.format("dddd") === "چهارشنبه"
    //         ) {

    //           dates.push({ isWeakend: true, date: now.locale('en').format("YYYY/MM/DD"),

    //           books_count:0,
    // disable_count:0,
    // is_custom_price:false,
    // price:

    //           });
    //         } else {
    //           dates.push({ date: now.locale('en').format("YYYY/MM/DD") });
    //         }

    //         now.add(1, "days");
    //       }
    //       return dates;
    //     },
    getDatesFromStartTo6Month() {
      // console.log(this.$moment)
      const endofMonth1 = this.$moment(this.date);
      const toDate1 = this.$moment(endofMonth).endOf("month");
      console.log(endofMonth1, toDate1);
      // console.log("monthsBetweenDates",this.monthsBetweenDates(endofMonth1,toDate1))
      // console.log("date",this.$options.filters.moment(this.date,"jD jMMMM,jYYYY HH:mm").getDay())
      // console.log(this.$moment(this.date).endOf('month').format('YYYY/MM/D'))
      const endofMonth = this.$moment(this.date).endOf("month");
      const toDate = this.$moment(endofMonth).add(6, "months").endOf("month");

      // console.log("toDate",toDate.format('YYYY/MM/D'))
      // console.log("monthsBetweenDates",this.monthsBetweenDates(endofMonth,toDate))
      var x = this.monthsBetweenDates(endofMonth1, toDate1);

      x.splice(-1);
      var y = this.monthsBetweenDates(endofMonth, toDate);
      // this.date.moment("jD jMMMM,jYYYY HH:mm").getDay()
      this.Dates = [...x, ...y];

      console.log(this.Dates);
      return this.Dates;
    },
    showFormModal(car, index) {
      this.$refs.carInput.specialServices = 0;

      console.log("car", car);
      if (car) {
        this.$refs.carInput.$refs.formWizard.activateAll()
        this.$refs.carInput.carInput = {
          id: car.id,
          name: car.name,
          slug: car.slug,
          host_id: car.host.id,
          category_id: car.category.id,
          similar_unit: car.similar_unit,
          min_day_before_reservation: car.min_day_before_reservation,
          min_people: car.min_people,
          max_people: car.max_people,
          max_baggage: car.max_baggage,
          description: car.description,
          covid: car.covid,
          blog_url: car.blog_url,
          faqs: car.faqs,
          car_style:car.car_style,
          car_class:car.car_class,
          car_gear:car.car_gear,
          car_carrier:car.car_carrier,
          max_capacity:car.max_capacity,
          price:car.price,
          price_type:car.price_type,
          price_off:car.price_off,
          rules: car.rules,
          show_index_page:car.show_index_page,
          score:car.score,
          show_date_page:car.show_date_page,
          // regulations: car.regulations,
          state_id: car.state.id,
          city_id: car.city.id,
          address: car.address,


         // prices: this.formatePrices(car.prices, "prices"),
          // special_services: this.formatePrices(
          //   car.special_services,
          //   "special_services"
          // ),
          special_services: car.special_services,
          commission_per_person: car.commission_per_person,
          commission_per_group: car.commission_per_group,

          lat: car.lat,
          lng: car.lng,
          status: car.status,
          agency: car.agency,
          close_booking: car.close_booking,
          seo_data_title: car.seo_data.title,
          seo_data_keywords: car.seo_data.keywords,
          seo_data_description: car.seo_data.description,
          seo_data_schema: car.seo_data.schema,
          videos: car.videos,
          podcasts: car.podcasts,
          status: car.status,
          close_booking: car.close_booking,
          images: car.images,
          show_order_number: car.show_order_number,
        };


        // (this.$refs.carInput.regulationsItemArray =
        //   car.regulations),
        this.$refs.carInput.categories =
            this.categories;



        var regulationsData = [];
    if(this.regulations.length>0){
        this.regulations.forEach(
            (initialRegulation, index) => {
              regulationsData.push(initialRegulation);
              car.regulations.forEach((saveRegulation) => {
                if (
                    initialRegulation.id == saveRegulation.car_regulation.id
                ) {
                  regulationsData[index] = saveRegulation;
                }
              });
            }
        );
}


if(this.rules.length>0){
        this.rules.forEach(
            (rule, index) => {
              if(car.rules){
                
              }
            
            }

         
        );
         
}


      
        this.$refs.carInput.helperRegulation = [...car.regulations];
        this.$refs.carInput.helperRules = [...car.rules];

 
        this.$refs.carInput.regulationsItemArray = regulationsData,
          
        this.$refs.carInput.rules = this.rules;
    

        if (Object.keys(car.special_services).length > 1) {
          this.$refs.carInput.specialServices =
              Object.keys(car.special_services).length - 1;
        } else {
          this.$refs.carInput.specialServices = 0;
        }

        // this.$refs.carInput.bedrooms = car.rooms.sumOfRooms;

        this.$refs.carInput.getCityByProvinceId(car.state.id);
        this.$refs.carInput.searchLatLng();
        this.$refs.carInput.carIndex = index;

        this.carIndex = index;
        this.editMode = true;
        this.$refs.carInput.dates = null;
        this.$refs.carInput.editMode = this.editMode;






      } 
      
      
      
      else {
        this.$refs.carInput.$refs.formWizard.reset ()

        this.$refs.carInput.carInput = {
          id: "",
          name: "",
          slug: "",
          host_id: "",
          category_id: "",
          similar_unit: "",
          min_day_before_reservation: "",
          min_people: "",
          max_people: "",
          max_baggage: "",
          show_index_page: "",
          show_date_page: "",
          score: "",
          covid: "",
          commission_per_person: "",
          commission_per_group: "",
          faqs: [],
          rules:[],
          // regulations:{},
          state_id: "",
          city_id: "",

      /*    prices: {
            priceType: "pricePerPeople",
            normal_dayes: "",
            weekend_days: "",
            peack_days: "",
            extra_guest: "",
            pricePerBaby: {
              name: "هزینه به ازای هر نوزاد",
              hasPrice: false,
              price: "",
            },
            pricePerAnimal: {
              name: "هزینه حیوانات",
              hasPrice: false,
              price: "",
            },
            images: [],
          },*/
          special_services: { 0: null },
          lat: "",
          lng: "",
          status: "",
          seo_data_title: "",
          seo_data_keywords: "",
          seo_data_description: "",
          seo_data_schema: "",
          videos: "",
          podcasts: "",
          status: "active",
          agency: "active",
        };


        this.$refs.carInput.categories =
            this.categories;

    
            (this.$refs.carInput.regulationsItemArray =
                this.regulations),
     

            (this.$refs.carInput.rules = this.rules);
        (this.$refs.carInput.specialServices = 0);
        // console.log(
        //   "this.autoimmune_packages_state",
        //   this.$store.state.app.autoimmune_packages_state
        // );
        // console.log(
        //   "this.regulations_state",
        //   this.$store.state.app.regulations_state
        // );
        // console.log(
        //   "this.packages_state",
        //   this.$store.state.app.packages_state
        // );
        // console.log(
        //   "this.health_items_state",
        //   this.$store.state.app.health_items_state
        // );
        // console.log("this.rules_state", this.$store.state.app.rules_state);
        this.$refs.carInput.carIndex = 0;

        this.editMode = false;
        this.$refs.carInput.editMode = this.editMode;
      }
      // this.$refs.carInput.dates=this.getDatesFromStartTo6Month()
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!errorMessage && !this.carInput.building_id) {
        errorMessage = "لطفا یک کاربر را انتخاب کنید";
      }
      if (!errorMessage && !this.carInput.name) {
        errorMessage = "لطفا رمز را وارد کنید";
      }

      if (!errorMessage && !this.carInput.description) {
        errorMessage = "لطفا توضیحات را وارد کنید";
      }

      if (!errorMessage && !this.carInput.body) {
        errorMessage = "لطفا متن را وارد کنید";
      }

      if (!errorMessage && !this.carInput.count) {
        errorMessage = "لطفا تعداد را وارد کنید";
      }

      if (!errorMessage && !this.carInput.bedrooms) {
        errorMessage = "لطفا تعداد اتاق خواب را وارد کنید";
      }

      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "patch" : "post",
        url: this.editMode
            ? `cars/${this.carInput.id}`
            : `cars`,
        data: this.carInput,
      };

      this.$http(requestData)
          .then((response) => {
            let message = "ترانسفر با موفقیت اضافه شد";
            if (this.editMode) message = "ترانسفر با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            if (!this.editMode && this.buildings && this.buildings.length > 0) {
              this.$refs.carsPaginationComponent.clear();
              this.$refs.carsSearchComponent.clear();
              this.$refs.carsTableHeadComponent.clear();
              this.page = 1;
              this.searchInput = "";
              this.sortBy = "";
              this.sortDir = "";
            }

            this.submitLoading = false;
            this.formModal = false;
            this.getCars();
          })
          .catch((err) => {
            let message = "خطا در ایجاد ترانسفر";
            if (this.editMode) message = "خطا در ویرایش ترانسفر";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },
    getBuildings(search, loading) {
      if (typeof this.buildingsCancelToken != typeof undefined) {
        this.buildingsCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.buildingsCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "buildings",
        params: data,
        cancelToken: this.buildingsCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data.data;
            this.buildings = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
